export const SET_MOCK_TESTS_DATA = "SET_MOCK_TESTS_DATA";
export const SET_MOCK_TESTS_RESULT_DATA = "SET_MOCK_TESTS_RESULT_DATA";
